class InputField {

    constructor(CegoXMPP) {
        this.CegoXMPP = CegoXMPP;
        this.textInput = null;
        this.chatType = null;
        this.receiver = null;
        this.visible = false;
    }

    getInput() {
        if (this.textInput === null) {
            this.textInput = jQuery('#chatText', this.chatContainer);
            window.savedSelection = 0;
            this.textInput.on("click", () => {
                window.savedSelection = document.getElementById('chatText').selectionStart;
            });
            this.textInput.on("keyup", (e) => {
                this.CegoXMPP.Emoticons.close();
                this.CegoXMPP.scrollToBottom();
                window.savedSelection = document.getElementById('chatText').selectionStart;
            });
        }
        return this.textInput;
    }

    reset() {
        this.smiley('hide');
        this.setPlaceholder(this.CegoXMPP.language.writeMessageHere);
        this.setReceiver(null);
        this.setChatType(null);
        this.clear();
    }

    hide() {
        this.visible = false;

        /* Navigation animation */
        if (this.CegoXMPP.UserSettings.get('showAnimations') === true) {
            this.getInput().parent().slideUp(this.CegoXMPP.ANIMATION_SPEED, function () {
                this.getInput().parent().hide();
                this.CegoXMPP.adjustBottom();
            }.bind(this));
        } else {
            this.getInput().parent().hide();
            this.CegoXMPP.adjustBottom();
        }
    }

    show() {
        this.visible = true;

        /* Navigation animation */
        if (this.CegoXMPP.UserSettings.get('showAnimations') === true) {
            this.getInput().parent().slideDown(this.CegoXMPP.ANIMATION_SPEED, function () {
                this.CegoXMPP.adjustBottom(function () {
                    this.CegoXMPP.scrollToBottom(true);
                }.bind(this));
            }.bind(this));
        } else {
            this.getInput().parent().show();
            this.CegoXMPP.scrollToBottom(true);
            // this.CegoXMPP.adjustBottom(function () {
            //     this.CegoXMPP.scrollToBottom(true);
            // }.bind(this));
        }
    }

    clear() {
        this.getInput().val('');
        this.enable();
        this.focus();
    }

    disable() {
        this.getInput().addClass("pulsate-fast").prop("disabled", true);
        setTimeout(() => this.enable(), 3000);
    }

    enable() {
        this.getInput().removeClass("pulsate-fast").prop("disabled", false);
    }

    autoGrow() {
        if (this.getInput().val().length === 0 || (this.getInput().get(0).scrollHeight !== this.getInput().outerHeight(true))) {
            this.CegoXMPP.adjustBottom();
        }
    }

    setChatType(chatType) {
        this.chatType = chatType;
    }

    setReceiver(receiver) {
        this.receiver = receiver;
    }

    setDirectChat(receiver) {
        this.reset();
        this.smiley('show');
        this.setChatType('chat');
        this.setReceiver(receiver);
        this.show();
        this.focus();
    }

    setChat() {
        this.reset();
        this.smiley('show');
        this.setChatType('groupchat');
        this.show();
    }

    focus() {
        this.getInput().focus();
    }

    blur() {
        this.getInput().blur();
    }

    setPlaceholder(str) {
        this.getInput().attr('placeholder', str);
    }

    smiley(action) {
        const item = jQuery('.chatInput .smiley');
        if (action === 'show') {
            item.off().on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                const bottom = this.getInput().parent().outerHeight(true);
                jQuery('.emoticonContainer').css('bottom', bottom);
                this.CegoXMPP.Emoticons.toggle();

            }.bind(this));

            item.show();
        } else {
            item.hide();
        }
    }

    setText(text) {
        this.getInput().val(text);
    }

    isVisible() {
        return this.visible;
    }
}